import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Modal, Alert, Button } from 'react-bootstrap';
import UserService from '../../services/UserService';

const ChamCongComponent = () => {
  const [position, setPosition] = useState(null);
  const [location, setLocation] = useState(null);
  const [loadingMessage, setLoadingMessage] = useState('Đang tải...');
  const [showDialog, setShowDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [modelsLoaded, setModelsLoaded] = useState(false);
  const [cameraActive, setCameraActive] = useState(false);
  const [isFaceDetected, setIsFaceDetected] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [lastChamCong, setLastChamCong] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const videoRef = useRef(null); // Tham chiếu video được khởi tạo ở đây
  const companyLocation = { latitude: 10.8486613, longitude: 106.6206993 };
  const allowedDistance = 500; // Giới hạn khoảng cách là 100 mét

  // useEffect để tải models, lấy vị trí và địa điểm khi trang được tải
  useEffect(() => {
    const initializeProcess = async () => {
      try {
        // Bước 1: Tải các models của Face API
        await loadFaceApiModels();

        // Bước 2: Yêu cầu cả quyền truy cập camera và vị trí cùng lúc
        const [cameraAccess, positionData] = await Promise.all([getCameraAccess(), getPosition()]);
        setPosition(positionData); // Cập nhật vị trí
        const locationName = await fetchLocationName(positionData.latitude, positionData.longitude);
        setLocation(locationName); // Cập nhật địa điểm
      } catch (error) {
        setLoadingMessage(`Lỗi khi tải dữ liệu: ${error.message || error}`);
      }
    };

    initializeProcess(); // Chạy khi component load lần đầu

    const fetchAttendanceData = async () => {
      try {
        const response = await UserService.getChamCongGanNhat();
        if (response.success) {
          setLastChamCong(response.data); // Cập nhật dữ liệu chấm công
        }
      } catch (error) {
        console.log('Có lỗi xảy ra khi tải dữ liệu chấm công.');
      }
    };

    fetchAttendanceData();

    // Dọn dẹp camera khi unmount component
    return () => {
      stopVideoStream();
    };
  }, []);


  useEffect(() => {
    // Kiểm tra nếu cả `position` và `location` đã có dữ liệu
    if (position && location) {
      startVideoProcess(); // Chỉ gọi khi cả hai đã được set
    }
  }, [position, location]); // Theo dõi sự thay đổi của `position` và `location`

  // Hàm tải các model của Face API
  const loadFaceApiModels = async () => {
    const MODEL_URL = '/face-api/models';
    try {
      if (window.faceapi) {
        await window.faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL);
        setModelsLoaded(true);
      } else {
        throw new Error('face-api.js chưa được tải');
      }
    } catch (error) {
      setLoadingMessage('Lỗi khi tải model nhận diện khuôn mặt.');
    }
  };

  // Hàm lấy quyền truy cập camera
  const getCameraAccess = () => {
    return new Promise((resolve, reject) => {
      const constraints = { video: { facingMode: 'user', width: { ideal: 640 }, height: { ideal: 480 } } };

      navigator.mediaDevices.getUserMedia(constraints)
        .then((stream) => {
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
            setCameraActive(true);
            resolve();
          } else {
            reject('Không tìm thấy phần tử video.');
          }
        })
        .catch((error) => {
          stopVideoStream(); // Dừng camera khi có lỗi
          reject(`Không thể truy cập camera: ${error.message}`);
        });
    });
  };

  // Hàm lấy vị trí của người dùng
  const getPosition = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const { latitude, longitude } = pos.coords;
            resolve({ latitude, longitude });
          },
          () => {
            reject('Không thể lấy vị trí.');
          },
          { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
        );
      } else {
        reject('Trình duyệt không hỗ trợ định vị.');
      }
    });
  };

  // Hàm lấy tên địa điểm từ API Vietmap
  const fetchLocationName = async (latitude, longitude) => {
    const apiKey = process.env.REACT_APP_VIETMAP_API_KEY;
    const url = `https://maps.vietmap.vn/api/reverse/v3?apikey=${apiKey}&lng=${longitude}&lat=${latitude}`;
    try {
      const response = await fetch(url);
      const data = await response.json();
      if (!data || !Array.isArray(data) || data.length === 0) {
        throw new Error('Không tìm thấy địa điểm.');
      }
      const locationName = data[0].display;
      return locationName;
    } catch (error) {
      return 'Lỗi khi lấy địa điểm';
    }
  };

  const handleButtonClick = (status) => {
    setIsDisabled(true); // Vô hiệu hóa cả hai nút ngay lập tức

    if (lastChamCong != null) {
      if (lastChamCong.loai_cham_cong === status) {
        setShowModal(true);
      } else {
        handleAttendance(status);
      }
    }
    else {      
      handleAttendance(status);
    }
  };

  // Hàm xử lý chấm công
  const handleAttendance = async (status) => {
    try {
      const distance = calculateDistance(position.latitude, position.longitude, companyLocation.latitude, companyLocation.longitude);
      if (distance > allowedDistance) {
        setLoadingMessage('Bạn đang ngoài phạm vi chấm công.');
        stopVideoStream(); // Tắt video nếu chấm công không hợp lệ
        return;
      }

      const imageDataURL = captureImage();
      if (!imageDataURL) {
        throw new Error('Không thể chụp ảnh từ camera.');
      }

      const user = localStorage.getItem('username');
      const timestamp = new Date().toISOString();

      const response = await UserService.chamCong(user, timestamp, position.latitude, position.longitude, location, imageDataURL, status);
      console.log(response);
      if (response.success) {
        setDialogMessage('Chấm công thành công!');
        setLoadingMessage('Chấm công thành công!');
        stopVideoStream();
      } else {
        setDialogMessage(`Chấm công thất bại: ${response.message}`);
        setLoadingMessage('Chấm công thất bại!');
        stopVideoStream();
      }
    } catch (error) {
      setDialogMessage(`${error.message}`);
      setLoadingMessage('Chấm công thất bại!');
      stopVideoStream();
    } finally {
      setIsFaceDetected(false);
      setShowDialog(true);
    }
  };

  const handleChamCongLai = async () => {
    const response = await UserService.xoaChamCong(lastChamCong.id);
    if (response.success) {
      handleAttendance(lastChamCong.loai_cham_cong)
    } else {
      alert('Có lỗi xảy ra khi chấm công lại. Vui lòng tải lại trang.')
    }
    setShowModal(false); // Đóng modal
  };

  const handleClose = () => {
    setShowModal(false); // Đóng modal
  };

  // Hàm khởi động camera và bắt đầu video nhận diện khuôn mặt
  const startVideoProcess = async () => {
    try {
      setLoadingMessage('Đang khởi động camera...');
      await getCameraAccess(); // Truy cập camera và gán stream vào videoRef.current

      // Sau khi getCameraAccess, đảm bảo videoRef.current tồn tại
      if (!videoRef.current) {
        handleError('Phần tử video chưa được khởi tạo.');
        return;
      }

      if (!modelsLoaded) {
        setLoadingMessage('Model chưa được tải.');
        return;
      }
      startVideo(); // Bắt đầu xử lý video sau khi camera và models đã sẵn sàng
    } catch (error) {
      handleError(error);
    }
  };

  // Hàm khởi chạy nhận diện khuôn mặt
  const startVideo = () => {
    const video = videoRef.current;
    const options = new window.faceapi.TinyFaceDetectorOptions({ inputSize: 224 });
    let intervalId;
    let timeoutId;

    // Hàm dừng nhận diện khuôn mặt
    const stopRecognition = () => {
      clearInterval(intervalId);    // Dừng interval
      clearTimeout(timeoutId);      // Hủy timeout nếu quá trình bị dừng trước khi hết 10 giây
    };

    // Khi video bắt đầu phát
    video.addEventListener('play', () => {
      // Thiết lập interval để kiểm tra khuôn mặt mỗi giây
      intervalId = setInterval(async () => {
        const detections = await window.faceapi.detectAllFaces(video, options);

        if (detections.length > 0) {
          clearInterval(intervalId);  // Dừng interval khi phát hiện khuôn mặt
          clearTimeout(timeoutId);    // Hủy timeout nếu khuôn mặt được phát hiện
          setIsFaceDetected(true);
          // await handleAttendance();   // Gọi hàm chấm công
        }
      }, 1000);

      // Dừng nhận diện sau 10 giây nếu không phát hiện khuôn mặt
      timeoutId = setTimeout(() => {
        stopRecognition();
        handleError('Không phát hiện khuôn mặt. Vui lòng thử lại.');
      }, 10000);
    }, { once: true });
  };

  // Hàm tính khoảng cách giữa hai tọa độ
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371e3;
    const φ1 = (lat1 * Math.PI) / 180;
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lon2 - lon1) * Math.PI) / 180;
    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  // Hàm chụp ảnh từ video
  const captureImage = () => {
    const video = videoRef.current;
    const canvas = document.createElement('canvas');

    // Giảm độ phân giải bằng cách chia tỷ lệ width và height (ví dụ: 50%)
    const scale = 1;
    canvas.width = video.videoWidth * scale;
    canvas.height = video.videoHeight * scale;

    // Lấy các thông tin từ localStorage và vị trí
    const name = localStorage.getItem('name') || 'Unknown';
    const timestamp = new Date().toISOString();
    const lat = position?.latitude || 'N/A';
    const lon = position?.longitude || 'N/A';
    const locationName = location || 'Không xác định';

    const context = canvas.getContext('2d');

    // Vẽ hình ảnh video vào canvas với độ phân giải giảm
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Đặt font chữ và màu sắc để vẽ text
    context.font = '12px Arial';
    context.fillStyle = 'white';
    context.strokeStyle = 'black';
    context.lineWidth = 3;

    // Vị trí để vẽ text (góc trái bên dưới)
    const padding = 10;
    const textX = padding;
    let textY = canvas.height - padding;

    // Vẽ thông tin tên
    const nameText = `Tên: ${name}`;
    context.strokeText(nameText, textX, textY); // Viền đen cho chữ
    context.fillText(nameText, textX, textY); // Chữ màu trắng
    textY -= 20;

    // Vẽ thông tin thời gian
    const timestampText = `Thời gian: ${new Date(timestamp).toLocaleString()}`;
    context.strokeText(timestampText, textX, textY);
    context.fillText(timestampText, textX, textY);
    textY -= 20;

    // Vẽ thông tin vị trí địa lý
    const positionText = `Vĩ độ: ${lat}, Kinh độ: ${lon}`;
    context.strokeText(positionText, textX, textY);
    context.fillText(positionText, textX, textY);
    textY -= 20;

    // Vẽ thông tin địa điểm
    const locationText = `Địa điểm: ${locationName}`;
    context.strokeText(locationText, textX, textY);
    context.fillText(locationText, textX, textY);

    // Chuyển đổi canvas thành base64
    return canvas.toDataURL('image/png');
  };

  // Xử lý lỗi và tắt camera
  const handleError = (error) => {
    setLoadingMessage(error.message || error);
    stopVideoStream();
  };

  // Dừng video và giải phóng camera
  const stopVideoStream = () => {
    const video = videoRef.current;
    if (video && video.srcObject) {  // Kiểm tra video và srcObject
      const stream = video.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      video.srcObject = null;  // Đặt lại srcObject về null sau khi dừng
    }
    setCameraActive(false);
  };

  return (
    <Container fluid>
      {lastChamCong && (
        <Modal show={showModal} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Bạn đã chấm công gần đây, bạn có muốn chấm công lại</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p><strong>Mã nhân viên:</strong> {lastChamCong.user_id}</p>
            <p><strong>Thời gian chấm công:</strong> {lastChamCong.thoi_gian_cham_cong}</p>
            <p><strong>Địa điểm chấm công:</strong> {lastChamCong.dia_diem_cham_cong}</p>
            <p><strong>Loại chấm công: </strong>Chấm công {lastChamCong.loai_cham_cong}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Hủy
            </Button>
            <Button variant="primary" onClick={handleChamCongLai}>
              Chấm công lại
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <Row>
        <Col>
          <h1 className="text-center mt-4">Chấm công tự động</h1>
          {isFaceDetected && (
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '30px', marginBottom: '1rem' }}>
              <Button variant="warning" className="mt-3" disabled={isDisabled} onClick={() => handleButtonClick('Vào')}>
                Chấm công vào
              </Button>
              <Button variant="success" className="mt-3" disabled={isDisabled} onClick={() => handleButtonClick('Ra')}>
                Chấm công ra
              </Button>
            </div>
          )}
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col xs={12} md={8}>
          <div id="video-container" style={{ position: 'relative' }}>
            {/* Video sẽ luôn hiển thị */}
            <video ref={videoRef} autoPlay playsInline muted style={{ width: '100%', height: 'auto' }} />
          </div>

          {/* Hiển thị thông báo nếu có vấn đề */}
          {!cameraActive && (
            <Alert variant="info" className="text-center">
              {loadingMessage}
            </Alert>
          )}
        </Col>
      </Row>

      <Modal show={showDialog} onHide={() => setShowDialog(false)} centered>
        <Modal.Body>
          <p className="text-center font-weight-bold">{dialogMessage}</p>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default ChamCongComponent;
